import { TourSalesModel } from 'api-hooks/tour/tour-sale';
import { ChevronDown } from 'baseui/icon';
import { CloseSVG } from 'common/assets';
import { string2money } from 'common/utils/string';
import { Form, Input } from 'components/elements';
import { Button, IconButton } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import { SeparatorHorizontal } from 'components/styles';
import useDrawer from 'hooks/use-drawer';
import { ButtonContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import SummaryDrawer from './summary-drawer';
import useRecalculate from '../../hooks/use-recalculate';
import {
  SummaryContent,
  SummaryLeftContainer,
  SummaryRightContainer,
} from '../../style';
import { TourSaleFormType } from '../form-type';

interface Props {
  tourSale?: TourSalesModel;
}

export default function SummaryTourSale(props: Props) {
  const { t } = useTranslation();
  const { tourSale } = props;
  const methods = useFormContext<TourSaleFormType>();
  const {
    formState: { isSubmitting },
    reset,
  } = methods;
  const drawer = useDrawer();

  const { total } = useRecalculate();

  const { editable, setIsEditable } = useFormState();

  const onOpenSummaries = React.useCallback(() => {
    drawer.showCustom({
      backdropClose: true,
      render: (close) => (
        <Form methods={methods} onSubmit={() => {}}>
          <SummaryDrawer onClose={close} />
        </Form>
      ),
    });
  }, [drawer, methods]);

  return (
    <SummaryContent>
      <SummaryLeftContainer>
        <Text variant={{ initial: 'LabelSmall', md: 'LabelLarge' }}>
          {`${t('common:total_sales')}:`}
        </Text>
        <SeparatorHorizontal $margin={16} />
        <Text variant={{ initial: 'HeadingXSmall', md: 'HeadingSmall' }}>
          {`Rp. ${string2money(total)}`}
        </Text>
        <SeparatorHorizontal $margin={16} />
        <IconButton buttonType="tertiary" onClick={onOpenSummaries}>
          <ChevronDown size={24} />
        </IconButton>
      </SummaryLeftContainer>
      <SummaryRightContainer>
        {editable && tourSale && !isSubmitting && (
          <>
            <ButtonContainer
              $style={{
                marginLeft: '16px',
              }}
            >
              <Button
                onClick={() => {
                  reset();
                  setIsEditable(false);
                }}
                buttonType="secondary"
                startEnhancer={(color, size) => (
                  <CloseSVG width={size} height={size} color={color} />
                )}
                disabled={isSubmitting}
              >
                {t('common:cancel')}
              </Button>
            </ButtonContainer>
            <SeparatorHorizontal $margin={16} />
          </>
        )}
        <Input
          type="submit"
          overrides={{
            Root: {
              style: {
                flex: 1,
              },
            },
          }}
        />
      </SummaryRightContainer>
    </SummaryContent>
  );
}
